import { render, staticRenderFns } from "./Subheader.vue?vue&type=template&id=6751f2a0&scoped=true"
import script from "./Subheader.vue?vue&type=script&lang=ts"
export * from "./Subheader.vue?vue&type=script&lang=ts"
import style0 from "./Subheader.vue?vue&type=style&index=0&id=6751f2a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6751f2a0",
  null
  
)

export default component.exports